export const COOKIE = 'clmgd'
export const BASKET_KEY = 'cln.basket.items'
export const INTENT_KEY = 'cl.intent'
export const ORDER_KEY = 'cl.orderId'
